import {
  SET_LINE_LIST,
  SET_LINE_LIST_WEB,
  SET_LINE_LIST_HTTP,
  SET_LINE_LIST_VPN,
} from './mutation-types'
import api from '@/api'
const state = {
  list: [],
  listWeb: [],
  listHttp: [],
  listVpn: [],
}

const mutations = {
  [SET_LINE_LIST] (state, payload) {
    state.list = payload
  },
  [SET_LINE_LIST_WEB] (state, payload) {
    state.listWeb = payload
  },
  [SET_LINE_LIST_HTTP] (state, payload) {
    state.listHttp = payload
  },
  [SET_LINE_LIST_VPN] (state, payload) {
    state.listVpn = payload
  },
}

const actions = {
  // 引擎--查询线路列表
  async queryEngineLines ({commit}, payload = {}) {
    let {data, code, message, result} = await api.transmissionApi.queryEngineLines(payload)
    if (data) commit(SET_LINE_LIST, data)
    return {data, code, message, result}
  },
  // 删除线路
  async deleteEngineLine ({dispatch}, payload) {
    let data = await api.transmissionApi.deleteEngineLine(payload)
    return data
  },
  // 新增修改线路
  async addOrUpdateEngineLine ({dispatch}, payload) {
    let data = await api.transmissionApi.addOrUpdateEngineLine(payload)
    if (data.code === 200) {
      dispatch('queryEngineLines', {zone: payload.zone || 1})
    }
    return data
  },

  // 网页端-查询线路列表
  async queryLineListWeb ({commit}, payload = {}) {
    let {data, code} = await api.transmissionApi.queryLineListWeb(payload)
    commit(SET_LINE_LIST_WEB, data)
    return {data, code}
  },
  // 网页端-删除线路
  async deleteLineWeb ({dispatch}, payload) {
    let data = await api.transmissionApi.deleteLineWeb(payload)
    return data
  },
  // 网页端-添加线路
  async addLineWeb ({dispatch}, payload) {
    let data = await api.transmissionApi.addLineWeb(payload)
    if (data.code === 200) {
      dispatch('queryLineListWeb', {zone: payload.zone || 1})
    }
    return data
  },
  // 网页端-更新线路
  async updateLineWeb ({dispatch}, payload) {
    let data = await api.transmissionApi.updateLineWeb(payload)
    if (data.code === 200) {
      dispatch('queryLineListWeb', {zone: payload.zone || 1})
    }
    return data
  },

  // HTTP-查询线路列表
  async queryLineListHttp ({commit}, payload = {}) {
    let {data, code} = await api.transmissionApi.queryLineListHttp(payload)
    commit(SET_LINE_LIST_HTTP, data)
    return {data, code}
  },
  // VPN-查询线路列表
  async queryVpnLines ({commit}, payload = {}) {
    let {data, code} = await api.transmissionApi.queryVpnLines(payload)
    commit(SET_LINE_LIST_VPN, data)
    return {data, code}
  },
  // VPN-删除线路
  async deleteLineVpn ({dispatch}, payload) {
    let data = await api.transmissionApi.deleteLineVpn(payload)
    if (data.code === 200) {
      dispatch('queryVpnLines', {})
    }
    return data
  },
  // HTTP-删除线路
  async deleteLineHttp ({dispatch}, payload) {
    let data = await api.transmissionApi.deleteLineHttp(payload)
    return data
  },
  // HTTP-添加线路
  async addLineHttp ({dispatch}, payload) {
    let data = await api.transmissionApi.addLineHttp(payload)
    if (data.code === 200) {
      dispatch('queryLineListHttp', {})
    }
    return data
  },
  // HTTP-更新线路
  async updateLineHttp ({dispatch}, payload) {
    let data = await api.transmissionApi.updateLineHttp(payload)
    if (data.code === 200) {
      dispatch('queryLineListHttp', {})
    }
    return data
  },
  // VPN-添加/更新线路
  async addOrUpdateVpnLines ({dispatch}, payload) {
    let data = await api.transmissionApi.addOrUpdateVpnLines(payload)
    if (data.code === 200) {
      dispatch('queryVpnLines', {})
    }
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
